import { COLORS } from "@/utils/constants/colors";

export const ERROR_MESSAGES = {
    NO_ROLE_SELECTED:"Please select a role to continue"
}
export const LOGO = "/images/logo.png";
export const ALL_ROLES = "all_roles";
export const ALL_GROUPS = "all_groups";
export const ALL_FEATURES = "all_features";
export const APPNAME = "GreenSign";
export const SUFFIX_PERSONAL = " (Personal)";
export const INVITED = "invited";
export const SEARCH_PLACEHOLDER = "Quick search";
export const DOCUMENT_SEARCH_PLACEHOLDER = "Search including documents";
export const YEAR = new Date().getFullYear();
export const COPYRIGHT_TEXT = `© ${YEAR} ${APPNAME}. All Rights Reserved.`;
export const MIN_PASSWORD_LENGTH = 12;
export const MAX_PASSWORD_LENGTH = 32;
export const RESEND_SUCCESS_MESSAGE_POPOVER_AUTOCLOSE_TIME = 5000;
export const IS_MOBILE = window.innerWidth < 768;
export const PAGE_LENGTH = 50;
export const ERROR_CODES = {
    IP_WHITELISTING_ERROR_CODE: 595,
    UPDATE_SUPER_ADMIN_ERROR_CODE: 559,
    WRONG_PASSWORD: 622,
    BAD_REQUEST: 400,
    CAPTCHA_V3_INVALID_TOKEN_ERROR_CODE: 632,
    CAPTCHA_NO_TOKEN_ERROR_CODE: 639
};
export const ALL_SIGNATURE_STYLES = [
    {
        key: "selected",
        name: "Font based signature",
    },
    {
        key: "draw",
        name: "Draw signature",
    },
    {
        key: "upload",
        name: "Upload signature image",
    },
];
export const ENVELOPE_STATUS = {
    DRAFT: "draft",
    SENT: "sent",
    COMPLETED: "completed",
    DECLINED: "declined",
    VOIDED: "voided",
    EXPIRED: "expired",
    DELETED: "deleted",
    NEED_TO_SIGN: "Need to Sign",
    CORRECTING: "correcting",
    DECLINED_TO_SIGN: "Declined to Sign",
};
export const colorStyles = {
    control: (styles: any, { selectProps: { selectedStatusOption }, isDisabled, isFocused, isSelected }: any) => {
        let borderColor = `1px solid ${COLORS.inputDefault}`;
        if (selectedStatusOption || !selectedStatusOption) {
            borderColor = `1px solid ${COLORS.primary}`;
        } else if (selectedStatusOption) {
            borderColor = `1px solid ${COLORS.primary}`;
        }
        return {
            ...styles,
            backgroundColor: isDisabled ? COLORS.disabled : COLORS.white,
            border: isDisabled ? `1px solid ${COLORS.border}` : borderColor,
            boxShadow: "none",
            minWidth: "120px",
            maxWidth: "400px",
            borderRadius: "4px",
            cursor: "pointer",
        };
    },
    option: (styles: any, { isDisabled, isFocused, isSelected }: any) => {
        return {
            ...styles,
            backgroundColor: isDisabled ? undefined : isFocused ? COLORS.surfaceHover : undefined,
            color: isSelected ? COLORS.cardForeground : isFocused ? COLORS.primary : undefined,
            cursor: isDisabled ? "not-allowed" : "default",
            ":active": {
                ...styles[":active"],
            },
        };
    },
    input: (styles: any) => ({ ...styles }),
    placeholder: (styles: any) => ({ ...styles }),
    multiValueRemove: (base: any, state: any) => ({
        ...base,
        cursor: "pointer",
        color: "gray",
        ":hover": {
            color: "gray",
        },
    }),
};
export const options = [
    {
        label: "All",
        value: "",
    },
    {
        label: "Active",
        value: true,
    },
    {
        label: "Suspened",
        value: false,
    },
];
export const StatusOptions = [
    {
        label: "All",
        value: "",
    },
    {
        label: "Completed",
        value: "completed",
    },
    {
        label: "Draft",
        value: "draft",
    },
    {
        label: "Expired",
        value: "expired",
    },
    {
        label: "Sent",
        value: "sent",
    },
    {
        label: "Correcting",
        value: "correcting",
    },
    {
        label: "Declined",
        value: "declined",
    },
    {
        label: "Voided",
        value: "voided",
    },

];
export const actionMap: any = {
    'CAN_SIGN': 'Needs to Sign', 'CAN_READ': 'Receives a Copy', 'CAN_INITIALS': 'Initials Only', 'CAN_STAMP': 'Stamp Only'
}
export const customDisposableDomains = [
    'blondmail.com',
    'guuysmail.com',
    'clowmail.com',
    'fivermail.com',
    'temptami.com',
    'tupmail.com',
    'replyloop.com',
    'chapsmail.com',
    'gimpmail.com',
    'getmule.com',
    'burnermail.io',
    'mytemp-mail.com',
    'temp-mail.org',
    'fakemailgenerator.com',
    'dispostable.com',
    '10minutemail.com',
    'emailondeck.com'
    // Add more custom domains here
];

export const ConnectorFor = {
    AD: 'active directory'
}
export const PORTAL_TYPE = {
    ADMIN: "admin",
    USER: "user"
}

export const AI_PROVIDER = {
    OPENAI: "Open AI",
    AZURE_OPENAI: "Azure Open AI",
    CLAUDE_AI: "Claude",
    GEMINI: "Gemini"
}

export const NOTIFICATION_EVENTS = {
    REFRESH_LOGOUT:'refresh_logout'
}
export const LOADING_TEXT = "Loading...";
export const TO_TEXT = "To";